/*
|--------------------------------------------------------------------------
| Serving Parameters
|--------------------------------------------------------------------------
|
| Here is where you can request or bind query parameters into
| JS variables accessible for use in tracking or other
| externally dependent information.
|
*/
window.getParameterByName = function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === '%%CLICK_URL_UNESC%%' || results === null
        ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

window.rand = Math.random();

/*
|--------------------------------------------------------------------------
| Tracking and Interaction
|--------------------------------------------------------------------------
|
| Here is where actions can be performed and tracked within the ad.
| DFP tracking will be done automatically while third party
| tracking should be provided directly in the URL.
|
*/
window.openAndTrack = function(useless, trackingUrl) {
    var turl;
    trackingUrl = trackingUrl.replace(/\[RANDOM\]/, window.rand);

    if (ct = window.getParameterByName('ct')) {
        trackingUrl = ct;
    }

    trackingUrl = trackingUrl.trim();
    if (turl = window.getParameterByName('turl')) {
        window.open(turl + trackingUrl, '_blank');
        return;
    }

    window.open(trackingUrl, '_blank');
};

window.downloadFile = function(file, trackingUrl) {
    trackingUrl = trackingUrl.replace(/\[RANDOM\]/, window.rand);
    if(trackingUrl != '')
        window.trackEvent('download', trackingUrl);
    window.open(file, '_blank');
}

window.trackImpression = function(useless, trackingUrl) {
    trackingUrl = trackingUrl.replace(/\[RANDOM\]/, window.rand);
    var xmlhttp;
    // compatible with IE7+, Firefox, Chrome, Opera, Safari
    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function(){};
    xmlhttp.open("GET", trackingUrl, true);
    xmlhttp.send();
};

window.trackEvent = function(useless, trackingUrl) {
    trackingUrl = trackingUrl.replace(/\[RANDOM\]/, window.rand);
    var xmlhttp;
    // compatible with IE7+, Firefox, Chrome, Opera, Safari
    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function(){};
    xmlhttp.open("GET", trackingUrl, true);
    xmlhttp.send();
};





/*
|--------------------------------------------------------------------------
| GIADC EDGE CORE
|--------------------------------------------------------------------------
*/


/**
* Main Giadc class
**/

var Giadc = (function(doc, win, Edge, helper) {

    'use strict';

    var config = {
        borderId: 'giadc-border'
    };

	/* constructor. most variables will be added in init() */
	var Giadc = function(){
		this.compId = [];
		this.composition = null;
		this.stage = null;
        this.stageElm = null;

        this._init();
	};

	Giadc.prototype = {


        helper: helper,


		/*
		* add task to perform here
		* This init will wait for Edge's composition is loaded
		*/

		_init: function() {
			var self = this;

			Edge.bootstrapCallback(function(compId) {
				self.compId = compId;
				self.composition = Edge.compositions[compId];
				self.stage = self.composition.getStage();
                self.stageElm = self.stage.getSymbolElement()[0];

                self.addBorder('rgba(0,0,0,0.7)');
			});
		},



		/* Add border to the stage
		 * + Remove border element if it already existed.
		 * + Generate 4 absolute corners divs by safely parsing html string
		 * + Add background-color in them
		 * + Append it into Stage
         * @param {String} color - Any string value of color
		 * @param {Integer} thickness - thickness of border
		 * @return none
		 */

		addBorder: function(color, thickness) {

			var thick = thickness || 1,
                n = '<div style="position:absolute; top:0; left:0; width:100%; height:'+thick+'px; background-color: '+color+';"></div>',
				e = '<div style="position:absolute; top:0; right:0; width:'+thick+'px; height:100%; background-color: '+color+';"></div>',
				s = '<div style="position:absolute; bottom:0; left:0; width:100%; height:'+thick+'px; background-color: '+color+';"></div>',
				w = '<div style="position:absolute; top:0; left:0; width:'+thick+'px; height:100%; background-color: '+color+';"></div>';
            helper.addElm( this.stageElm, n, config.borderId+'-n' );
			helper.addElm( this.stageElm, e, config.borderId+'-e' );
			helper.addElm( this.stageElm, s, config.borderId+'-s' );
			helper.addElm( this.stageElm, w, config.borderId+'-w' );
            return this;
		},


	};

	return Giadc;

}( document,
    window,
    AdobeEdge,

    // Helper functions
    {
        /**
        * Parse HTML string safely and return element.
        * 1. Spawn it inside an hidden iframe
        * 2. Extract the HTML DOM element
        * 3. Remove the iframe and return the element
        **/

        HTMLParser: function(htmlString){
    		var frame = document.createElement('iframe'), el;
    		frame.style.display = 'none';
    		document.body.appendChild(frame);
    		frame.contentDocument.open();
    		frame.contentDocument.write(htmlString);
    		frame.contentDocument.close();
    		el = frame.contentDocument.body.firstChild;
    		document.body.removeChild(frame);
    		return el;
    	},



    	// Empty a DOM element
    	emptyElm: function(el) {
    		if(!el || !el.parentNode) return;
    		if(el.firstChild) {
    			while (el.firstChild) el.removeChild(el.firstChild);
    		}
    		el.parentNode.removeChild(el);
    	},



    	/*
    	 * Add DOM element into a parent
    	 * It will also remove the old element before adding
    	 *
    	 * @param {DOM} parent
    	 * @param {String} html string
    	 * @param {String} id of the element
    	 * @return {DOM} newly added node
    	 */

    	addElm: function( parent, html, id ) {
    		if(!parent || html==='' || id==='') return false;

    		var node = this.HTMLParser(html);

    		this.emptyElm(document.getElementById(id));

    		node.id = id;
    		parent.appendChild(node);
    		return node;
    	},



        /**
        * Add a JS tag into head and callback when it's loaded
        *
        * @param {String} url - Url of the script
        * @param {Function} callback - [optional] will execute when callback defined
        **/

        addJsTag: function(url, /* optional */ callback) {
            var tag = document.createElement('script'),
                firstScriptTag = document.getElementsByTagName('script')[0];
            tag.src = url;
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // callback when load successfully
            if(callback) {
                tag.addEventListener('load', function(e) {
                    callback(e, url);
                }, false);

                tag.addEventListener('error', function() {
                    console.warn('cannot load '+url);
                });
            }
        },



        /**
        * Recursively add an array of js files synchronously
        *
        * @param {Array} urlArray - Array of JS files' urls
        * @param {Function} callback - [optional] will execute when callback defined
        * @param {Integer} index - [internal use only] index of the current loading script
        **/

        addJsFiles: function(urlArray, /* optional */ callback, /* internal use only */ index ) {
            var idx = index || 0;
            this.addJsTag(urlArray[idx], function(e, url){
                if(idx === (urlArray.length-1)) {
                    if(callback) callback();
                } else {
                    idx++;
                    this.addJsFiles(urlArray, callback, idx);
                }
            }.bind(this));
        },



        /**
        * Check if the browser is of mobile/tablet
        **/

        checkMobile: function() {
            return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
        },


    }
));

window.giadc = new Giadc();
